var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconclear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM10.1968 11.4698C10.4897 11.7627 10.4897 12.2376 10.1968 12.5305L7.89386 14.8335C7.60096 15.1263 7.60096 15.6012 7.89386 15.8941L8.10599 16.1062C8.39888 16.3991 8.87375 16.3991 9.16665 16.1062L11.4696 13.8033C11.7625 13.5104 12.2374 13.5104 12.5303 13.8033L14.8332 16.1062C15.1261 16.3991 15.601 16.3991 15.8939 16.1062L16.106 15.8941C16.3989 15.6012 16.3989 15.1263 16.106 14.8335L13.8031 12.5305C13.5102 12.2376 13.5102 11.7627 13.8031 11.4698L16.106 9.16689C16.3989 8.874 16.3989 8.39913 16.106 8.10623L15.8939 7.8941C15.601 7.60121 15.1261 7.60121 14.8332 7.8941L12.5303 10.1971C12.2374 10.4899 11.7625 10.4899 11.4696 10.197L9.16665 7.8941C8.87375 7.60121 8.39888 7.60121 8.10599 7.8941L7.89386 8.10623C7.60096 8.39912 7.60096 8.874 7.89386 9.16689L10.1968 11.4698Z",
    fill: "#3B5118"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconclear);
export default __webpack_public_path__ + "static/media/icon.clear.92ddeea237b50e9ded133727f07fa48e.svg";
export { ForwardRef as ReactComponent };